import { RecentlyWatchedTVTray } from '../../../domain/recently-watched-tv-tray';
import {
  CreateRecentlyWatchedTvPageItemRequestApiModel,
  RecentlyWatchedTvPageItemApiModel,
  UpdateRecentlyWatchedTvPageItemRequestApiModel,
} from '@cxb/editor-stb-api';
import { mapperPipe, remainderMapper } from 'osn-shared';
import {
  displayServiceTypeIconMapperDomainToApi,
  nameLocalizedMapperDomainToApi,
  scheduledDateMapperDomainToApi,
  targetingMapperDomainToApi,
} from '../../mapping/create-tray-domain-to-api';
import {
  commonMapper,
  displayServiceTypeIconMapperApiToDomain,
  nameLocalizedMapperApiToDomain,
  scheduledDateMapperApiToDomain,
  targetingMapperApiToDomain,
} from '../../mapping/create-tray-api-to-domain';
import { RecentlyWatchedTVTrayFormViewModel } from './recently-watched-tv-tray-form.view-model';
import { TrayFormViewModelType } from '../view-model-common/view-model-type';
import {
  displayServiceTypeIconMapper,
  nameLocalizedMapperDomainToViewModel,
  scheduledDateMapperDomainToViewModel,
  targetingMapper,
} from '../create-tray-screen/mapping/create-tray-domain-to-vm';
import {
  nameLocalizedMapperViewModelToDomain,
  scheduledDateMapperViewModelToDomain,
} from '../create-tray-screen/mapping/create-tray-vm-to-domain';

// 'RecentlyWatchedTV'

/**
 * DOMAIN -> API
 */

export const mapRecentlyWatchedTVTrayDomainModelToApiModel = (
  item: RecentlyWatchedTVTray,
  pageVersionId?: string,
  tenantId?: string
): CreateRecentlyWatchedTvPageItemRequestApiModel & UpdateRecentlyWatchedTvPageItemRequestApiModel => {
  const commonProperties = mapperPipe(
    item,
    nameLocalizedMapperDomainToApi,
    targetingMapperDomainToApi,
    scheduledDateMapperDomainToApi,
    displayServiceTypeIconMapperDomainToApi
  );

  return remainderMapper(commonProperties, () => ({
    pageVersionId,
    limit: item.maxItemsDisplayedInTray,
    tenantId,
  }));
};

/**
 * API -> DOMAIN
 */

export const mapRecentlyWatchedTVTrayApiModelToDomainModel = (
  recentlyWatchedTVPageItem: RecentlyWatchedTvPageItemApiModel
): RecentlyWatchedTVTray => {
  return remainderMapper(
    mapperPipe(
      recentlyWatchedTVPageItem,
      commonMapper,
      nameLocalizedMapperApiToDomain,
      targetingMapperApiToDomain,
      scheduledDateMapperApiToDomain,
      displayServiceTypeIconMapperApiToDomain
    ),
    () => ({
      type: 'RecentlyWatchedTV',
      maxItemsDisplayedInTray: recentlyWatchedTVPageItem.limit,
    })
  );
};

/**
 * DOMAIN -> VIEWMODEL
 */

export const mapRecentlyWatchedTVTrayDomainModelToViewModel = (
  recentlyWatchedTVItem: RecentlyWatchedTVTray
): RecentlyWatchedTVTrayFormViewModel => {
  const commonProperties = mapperPipe(
    recentlyWatchedTVItem,
    commonMapper,
    nameLocalizedMapperDomainToViewModel,
    targetingMapper,
    scheduledDateMapperDomainToViewModel,
    displayServiceTypeIconMapper
  );

  return remainderMapper(commonProperties, () => ({
    type: TrayFormViewModelType.RecentlyWatchedTV,
    maxItemsDisplayedInTray: recentlyWatchedTVItem.maxItemsDisplayedInTray,
  }));
};

/**
 * VIEWMODEL -> DOMAIN
 */

export const mapRecentlyWatchedTVTrayViewModelToDomainModel = (vm: RecentlyWatchedTVTrayFormViewModel): RecentlyWatchedTVTray => {
  const commonProperties = mapperPipe(
    vm,
    commonMapper,
    nameLocalizedMapperViewModelToDomain,
    targetingMapper,
    scheduledDateMapperViewModelToDomain,
    displayServiceTypeIconMapper
  );

  return remainderMapper(commonProperties, () => ({
    type: 'RecentlyWatchedTV',
    maxItemsDisplayedInTray: vm.maxItemsDisplayedInTray,
  }));
};
